export const SOSTOSLISTA_CLIENT_NAME = 'SOSTOSLISTA' as const
